// Email Editor Constants

export const DESIGN_LOCKED_PROPERTIES = []

export const CAMPAIGN_BODY_EDITABLE_PROPERTIES = ['emailTitle', 'bodyHtml', 'ctaText']

export const CAMPAIGN_INBOX_EDITABLE_PROPERTIES = ['subject', 'preheaderText']

export const LEGACY_DESIGN_BODY_PLACEHOLDER =
  'Campaign message text is customized per invite campaign on the Text tab.'

export const injectedScript = `
<script>
  (function() {
    if (window.parent && typeof window.parent.handleIframeClick === 'function') {
      document.addEventListener('click', window.parent.handleIframeClick, true);
    }
  })();
</script>
`

export const sectionsToProperties = {
  header: ['headerBgColor', 'logoUrl', 'headerTaglineScript', 'headerTaglineSans'],
  hero: ['heroImgUrl', 'heroImg2', 'heroImg3', 'heroImg4', 'heroAnimatedImgUrl', 'heroImageLinkUrl', 'heroOverlayText'],
  body: [
    'introKicker',
    'emailTitle',
    'bodyHtml',
    'ctaText',
    'ctaBackgroundColor',
    'ctaTextColor',
    'secondaryCtaText',
    'secondaryCtaUrl'
  ],
  col1: [
    'featuresSectionKicker',
    'featuresSectionTitle',
    'col1Image',
    'col1ImageLinkUrl',
    'col1Html',
    'col1LinkText',
    'col1LinkUrl',
    'discoverBtn1',
    'discoverBtn1LinkUrl',
    'discoverBtn2',
    'discoverBtn2LinkUrl',
    'discoverBtn3',
    'discoverBtn3LinkUrl',
    'discoverBtn4',
    'discoverBtn4LinkUrl',
    'discoverIntroText'
  ],
  discoverIntro: ['galleryTitle', 'discoverIntroText'],
  discoverButtons: [
    'discoverBtn1',
    'discoverBtn1LinkUrl',
    'discoverBtn2',
    'discoverBtn2LinkUrl',
    'discoverBtn3',
    'discoverBtn3LinkUrl',
    'discoverBtn4',
    'discoverBtn4LinkUrl'
  ],
  col2: ['col2Image', 'col2ImageLinkUrl', 'col2Html', 'col2LinkText', 'col2LinkUrl'],
  col3: ['col3Image', 'col3ImageLinkUrl', 'col3Html', 'col3LinkText', 'col3LinkUrl'],
  experiencesIntro: ['featuresSectionTitle'],
  gallery: [
    'galleryKicker',
    'galleryTitle',
    'gallery1Image',
    'gallery1ImageLinkUrl',
    'gallery2Image',
    'gallery2ImageLinkUrl',
    'gallery3Image',
    'gallery3ImageLinkUrl',
    'gallery4Image',
    'gallery4ImageLinkUrl',
    'galleryCaption1',
    'galleryCaption2',
    'galleryCaption3',
    'galleryCaption4'
  ],
  personal: ['personalHtml'],
  lifestyle: ['lifestyleImage', 'lifestyleImageLinkUrl', 'lifestyleImageAlt'],
  socialProof: ['socialQuote', 'socialAuthor', 'socialGuestImage', 'socialGuestImageLinkUrl'],
  experiences: [
    'experiencesKicker',
    'featuresSectionTitle',
    'exp1Title',
    'exp1Image',
    'exp1ImageLinkUrl',
    'exp2Title',
    'exp2Image',
    'exp2ImageLinkUrl',
    'exp3Title',
    'exp3Image',
    'exp3ImageLinkUrl',
    'exp4Title',
    'exp4Image',
    'exp4ImageLinkUrl'
  ],
  offer: ['offerKicker', 'offerTitle', 'offerBody', 'offerDate1', 'offerDate2', 'offerDate3'],
  footer: ['socialMediaLinks', 'footerAccentColor', 'finePrintHtml', 'hotelPhone', 'hotelWebsite', 'hotelWebsiteUrl'],
  'inbox-preview': ['subject', 'preheaderText']
}

export const propertyTypes = {
  headerBgColor: 'color',
  logoUrl: 'image',
  heroImgUrl: 'image',
  heroImg2: 'image',
  heroImg3: 'image',
  heroImg4: 'image',
  heroAnimatedImgUrl: 'image',
  heroImageLinkUrl: 'url',
  emailTitle: 'text',
  introKicker: 'text',
  headerTaglineScript: 'text',
  headerTaglineSans: 'text',
  heroOverlayText: 'text',
  discoverIntroText: 'text',
  footerAccentColor: 'color',
  finePrintHtml: 'richtext',
  bodyHtml: 'richtext',
  col1Image: 'image',
  col1ImageLinkUrl: 'url',
  col1Html: 'richtext',
  col1LinkText: 'text',
  col1LinkUrl: 'url',
  col2LinkText: 'text',
  col2LinkUrl: 'url',
  featuresSectionKicker: 'text',
  featuresSectionTitle: 'text',
  col2Image: 'image',
  col2ImageLinkUrl: 'url',
  col2Html: 'richtext',
  col3Image: 'image',
  col3ImageLinkUrl: 'url',
  col3Html: 'richtext',
  col3LinkText: 'text',
  col3LinkUrl: 'url',
  discoverBtn1: 'text',
  discoverBtn1LinkUrl: 'url',
  discoverBtn2: 'text',
  discoverBtn2LinkUrl: 'url',
  discoverBtn3: 'text',
  discoverBtn3LinkUrl: 'url',
  discoverBtn4: 'text',
  discoverBtn4LinkUrl: 'url',
  gallery1Image: 'image',
  gallery1ImageLinkUrl: 'url',
  gallery2Image: 'image',
  gallery2ImageLinkUrl: 'url',
  gallery3Image: 'image',
  gallery3ImageLinkUrl: 'url',
  gallery4Image: 'image',
  gallery4ImageLinkUrl: 'url',
  galleryKicker: 'text',
  galleryTitle: 'text',
  galleryCaption1: 'text',
  galleryCaption2: 'text',
  galleryCaption3: 'text',
  galleryCaption4: 'text',
  personalHtml: 'richtext',
  lifestyleImage: 'image',
  lifestyleImageLinkUrl: 'url',
  lifestyleImageAlt: 'text',
  socialQuote: 'text',
  socialAuthor: 'text',
  socialGuestImage: 'image',
  socialGuestImageLinkUrl: 'url',
  experiencesKicker: 'text',
  exp1Title: 'text',
  exp1Desc: 'text',
  exp1Image: 'image',
  exp1ImageLinkUrl: 'url',
  exp2Title: 'text',
  exp2Desc: 'text',
  exp2Image: 'image',
  exp2ImageLinkUrl: 'url',
  exp3Title: 'text',
  exp3Desc: 'text',
  exp3Image: 'image',
  exp3ImageLinkUrl: 'url',
  exp4Title: 'text',
  exp4Image: 'image',
  exp4ImageLinkUrl: 'url',
  offerKicker: 'text',
  offerTitle: 'text',
  offerBody: 'text',
  offerDate1: 'text',
  offerDate2: 'text',
  offerDate3: 'text',
  ctaText: 'text',
  ctaBackgroundColor: 'color',
  ctaTextColor: 'color',
  secondaryCtaText: 'text',
  secondaryCtaUrl: 'url',
  privacyPolicyUrl: 'url',
  hotelPhone: 'text',
  hotelWebsite: 'text',
  hotelWebsiteUrl: 'url',
  termsUrl: 'url',
  socialMediaLinks: 'socialmedia',
  preheaderText: 'multilinetext',
  subject: 'text'
}

export const propertyNames = {
  headerBgColor: 'Header background color',
  logoUrl: 'Logo',
  heroImgUrl: 'Hero frame 1',
  heroImg2: 'Hero frame 2',
  heroImg3: 'Hero frame 3',
  heroImg4: 'Hero frame 4',
  heroAnimatedImgUrl: 'Hero slideshow (GIF)',
  heroImageLinkUrl: 'Hero image link URL',
  emailTitle: 'Heading',
  introKicker: 'Intro label',
  headerTaglineScript: 'Header tagline (script)',
  headerTaglineSans: 'Header tagline (sans)',
  heroOverlayText: 'Hero overlay text',
  discoverIntroText: 'Discover intro text',
  footerAccentColor: 'Footer accent color',
  finePrintHtml: 'Fine print',
  bodyHtml: 'Campaign content',
  body: 'Body',
  ctaText: 'Button text',
  ctaBackgroundColor: 'Button background color',
  privacyPolicyUrl: 'Privacy policy URL',
  hotelPhone: 'Hotel phone',
  hotelWebsite: 'Hotel website label',
  hotelWebsiteUrl: 'Hotel website URL',
  termsUrl: 'Terms of service URL',
  socialMediaLinks: 'Social media links',
  subject: 'Email subject',
  preheaderText: 'Preheader text',
  col1Image: 'Column 1 image',
  col1ImageLinkUrl: 'Column 1 image link URL',
  col1Html: 'Column 1 content',
  col1LinkText: 'Learn more link text',
  col1LinkUrl: 'Learn more link URL',
  col2LinkText: 'Learn more link text',
  col2LinkUrl: 'Learn more link URL',
  featuresSectionKicker: 'Features section kicker',
  featuresSectionTitle: 'Features section title',
  col2Image: 'Column 2 image',
  col2ImageLinkUrl: 'Column 2 image link URL',
  col2Html: 'Column 2 content',
  col3Image: 'Story image',
  col3ImageLinkUrl: 'Story image link URL',
  col3Html: 'Story content',
  col3LinkText: 'Button text',
  col3LinkUrl: 'Button URL',
  featuresSectionTitle: 'Section heading',
  discoverBtn1: 'Discover button 1',
  discoverBtn1LinkUrl: 'Discover button 1 link URL',
  discoverBtn2: 'Discover button 2',
  discoverBtn2LinkUrl: 'Discover button 2 link URL',
  discoverBtn3: 'Discover button 3',
  discoverBtn3LinkUrl: 'Discover button 3 link URL',
  discoverBtn4: 'Discover button 4',
  discoverBtn4LinkUrl: 'Discover button 4 link URL',
  gallery1Image: 'Gallery image 1',
  gallery1ImageLinkUrl: 'Gallery image 1 link URL',
  gallery2Image: 'Gallery image 2',
  gallery2ImageLinkUrl: 'Gallery image 2 link URL',
  gallery3Image: 'Gallery image 3',
  gallery3ImageLinkUrl: 'Gallery image 3 link URL',
  gallery4Image: 'Gallery image 4',
  gallery4ImageLinkUrl: 'Gallery image 4 link URL',
  galleryKicker: 'Gallery label',
  galleryTitle: 'Gallery heading',
  galleryCaption1: 'Gallery caption 1',
  galleryCaption2: 'Gallery caption 2',
  galleryCaption3: 'Gallery caption 3',
  galleryCaption4: 'Gallery caption 4',
  personalHtml: 'Personal note',
  lifestyleImage: 'Lifestyle image',
  lifestyleImageLinkUrl: 'Lifestyle image link URL',
  lifestyleImageAlt: 'Lifestyle image alt text',
  socialQuote: 'Guest quote',
  socialAuthor: 'Guest name',
  socialGuestImage: 'Guest photo',
  socialGuestImageLinkUrl: 'Guest photo link URL',
  experiencesKicker: 'Experiences label',
  exp1Title: 'Experience 1 title',
  exp1Desc: 'Experience 1 description',
  exp1Image: 'Experience 1 image',
  exp1ImageLinkUrl: 'Experience 1 image link URL',
  exp2Title: 'Experience 2 title',
  exp2Desc: 'Experience 2 description',
  exp2Image: 'Experience 2 image',
  exp2ImageLinkUrl: 'Experience 2 image link URL',
  exp3Title: 'Experience 3 title',
  exp3Desc: 'Experience 3 description',
  exp3Image: 'Experience 3 image',
  exp3ImageLinkUrl: 'Experience 3 image link URL',
  exp4Title: 'Experience 4 title',
  exp4Image: 'Experience 4 image',
  exp4ImageLinkUrl: 'Experience 4 image link URL',
  offerKicker: 'Offer label',
  offerTitle: 'Offer heading',
  offerBody: 'Offer description',
  offerDate1: 'Offer date 1',
  offerDate2: 'Offer date 2',
  offerDate3: 'Offer date 3',
  secondaryCtaText: 'Secondary button text',
  secondaryCtaUrl: 'Secondary button URL',
  ctaTextColor: 'Button text color'
}

export const editableSectionClasses = [
  'mjml-header',
  'mjml-hero',
  'mjml-body',
  'mjml-footer',
  'mjml-col1',
  'mjml-col2',
  'mjml-col3',
  'mjml-experiencesIntro',
  'mjml-discoverIntro',
  'mjml-discoverButtons',
  'mjml-gallery',
  'mjml-personal',
  'mjml-lifestyle',
  'mjml-social-proof',
  'mjml-experiences',
  'mjml-offer',
  'mjml-inbox-preview'
]

export const sections = {
  header: 'header',
  hero: 'hero',
  body: 'body',
  footer: 'footer',
  col1: 'col1',
  col2: 'col2',
  col3: 'col3',
  experiencesIntro: 'experiencesIntro',
  discoverIntro: 'discoverIntro',
  discoverButtons: 'discoverButtons',
  gallery: 'gallery',
  personal: 'personal',
  lifestyle: 'lifestyle',
  socialProof: 'socialProof',
  experiences: 'experiences',
  offer: 'offer',
  'inbox-preview': 'inbox-preview'
}

export const editableSectionNames = {
  header: 'Header',
  hero: 'Hero',
  body: 'Campaign content',
  footer: 'Footer',
  col1: 'Property highlights',
  col2: 'Guest experience',
  col3: 'Experience story',
  experiencesIntro: 'Experiences heading',
  discoverIntro: 'Discover intro',
  discoverButtons: 'Discover buttons',
  gallery: 'Photo gallery',
  personal: 'Personal note',
  lifestyle: 'Lifestyle banner',
  socialProof: 'Guest testimonial',
  experiences: 'Curated experiences',
  offer: 'Exclusive offer',
  'inbox-preview': 'Inbox preview'
}

export const defaultEmailState = {
  headerBgColor: '#999999',
  logoUrl: '/sample-hotel-logo.png',
  heroImgUrl: 'https://placehold.co/500x220',
  heroImageLinkUrl: '',
  body: `
Lorem ipsum dolor sit amet consectetur adipisicing elit. ***Necessitatibus explicabo*** quo illo tempora fuga reprehenderit non culpa nemo rem perferendis.

~~Old~~ New Return on *Investment page* lets group managers easily see the value SwayPay brings to all **hotels** under the managament group at a glance. 
`,
  preheaderText: 'This is the preview text',
  subject: 'This is the email subject',
  emailTitle: 'This is a header of the email',
  ctaText: 'Book now!',
  ctaBackgroundColor: '#999999',
  hotelName: 'Kailani Resorts - New York',
  hotelAddress: '123 Apple St',
  hotelCityStateZip: 'New York, NY 10002',
  privacyPolicyUrl: '#',
  termsUrl: '#',
  socialMediaLinks: [
    { platform: 'facebook', url: '#' },
    { platform: 'twitter', url: '#' },
    { platform: 'instagram', url: '#' },
    { platform: 'linkedin', url: '#' },
    { platform: 'youtube', url: '#' }
  ],
  ctaTextColor: '#ffffff'
}
